import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-night" data-id="element-55" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-56" data-mp="1gcxsapvh5c2f">
        <h2 className="text-center font-display text-[1.75rem] font-semibold tracking-tight text-parchment sm:text-4xl" data-id="element-57" data-mp="1gauql8kyluhv">
          Preguntas frecuentes
        </h2>

        <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-58" data-mp="292o4gtdjq3vw">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-night-line bg-night-panel" data-id="element-59" data-mp="1z3ynr3xdyph8" data-mpi={index}>
                <h3 data-id="element-60" data-mp="skqrneipuix7">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 px-5 py-4 text-left font-sans text-base font-semibold text-parchment sm:gap-6 sm:px-6 sm:py-5 transition-colors duration-150 ease-out hover:text-gold-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft" data-id="element-61" data-mp="nniha03t7j6i">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 flex-none text-gold-soft transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-62" data-mp="6plou4gb1k61" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-63" data-mp="3jxq4vl1gsff4">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-64" data-mp="3nzbnln0ojnx8">
                      <p className="px-5 pb-5 font-sans text-[0.95rem] leading-relaxed text-parchment/70 sm:px-6 sm:pb-6" data-id="element-65" data-mp="1koynehymsfkr">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}